/* eslint-disable camelcase */

import { SWRConfiguration } from "swr";
import { ApiResponse, ServerResponse } from "./axiosConfig";
import { useSwr as useSwrHvs } from "./axiosHVS";

export interface NotificationTemplate extends Record<string, unknown> {
  content: string;
  id: string;
  domain_id: string;
  name: string;
  subject: string;
  template_nr: number;
  sequence: number;
  default: boolean;
  active?: boolean;
}
export interface NotificationTemplateDocument extends Record<string, unknown> {
  id: string;
  templates?: NotificationTemplate[];
}

export const useNotificationTemplate = (
  id?: string,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<NotificationTemplateDocument>> =>
  useSwrHvs<ApiResponse<NotificationTemplateDocument>>(
    id != null ? `documents/${id}` : null,
    config
  );
